<template>
    <router-view />
</template>
  
<script>
  export default {
    name: "WordOfMouth",
  };
</script>
  